import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
// @ts-ignore
const logoCentralis = require('../../assets/logo/logo-centralis-gris.png');
// @ts-ignore
const bandeauCentralis = require('../../assets/logo/bandeau-centralis.png');

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontSize: 12,
    fontFamily: 'Helvetica',
    backgroundColor: '#FFFDFC'
  },
  bandeau: {
    width: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
    paddingBottom: 16
  },
  logo: {
    width: 100,
    marginRight: 16
  },
  userInfo: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'right'
  },
  dateInfo: {
    fontSize: 12,
    color: '#6B7280',
    textAlign: 'right',
    marginTop: 4
  },
  infoSection: {
    padding: 16,
    marginHorizontal: 24,
    marginBottom: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB'
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 8
  },
  infoLabel: {
    fontWeight: 'bold',
    width: '40%',
    fontSize: 11
  },
  infoValue: {
    flex: 1,
    fontSize: 11
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    padding: 12,
    marginHorizontal: 24,
    marginTop: 16,
    marginBottom: 8,
    borderRadius: 8
  },
  sectionContent: {
    marginHorizontal: 24,
    marginBottom: 16
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 4
  },
  fieldValue: {
    fontSize: 11,
    marginBottom: 12,
    lineHeight: 1.4
  },
  prestaComparison: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 12
  },
  prestaColumn: {
    flex: 1,
    padding: 8
  },
  prestaHeader: {
    backgroundColor: 'rgba(194, 194, 194, 0.5)',
    paddingVertical: 6,
    paddingHorizontal: 8,
    marginBottom: 8,
    textAlign: 'center',
    borderRadius: 8
  },
  prestaName: {
    fontWeight: 'bold',
    fontSize: 8,
    marginBottom: 4
  },
  prestaDate: {
    fontSize: 6,
    color: '#6B7280'
  },
  responseTechnique: {
    fontSize: 5,
    marginBottom: 8,
    marginTop: 4
  },
  critereTitle: {
    fontSize: 6,
    fontWeight: 'bold',
    marginTop: 6,
    marginBottom: 2
  },
  critereResponse: {
    fontSize: 5,
    marginBottom: 6,
    lineHeight: 1.3
  },
  noteSection: {
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
    marginTop: 8
  },
  noteTitle: {
    fontSize: 6,
    fontWeight: 'bold',
    marginBottom: 2
  },
  noteValue: {
    fontSize: 6,
    marginBottom: 2
  },
  notesGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 4,
    gap: 5
  },
  noteItem: {
    flex: 1
  },
  noteLabel: {
    fontSize: 4,
    color: '#6B7280',
    marginBottom: 2
  },
  financeTable: {
    marginTop: 10,
    fontSize: 10
  },
  tableRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    paddingVertical: 4
  },
  tableHeaderRow: {
    backgroundColor: 'rgba(215, 217, 217, 0.25)',
    fontWeight: 'bold'
  },
  tableCell: {
    flex: 1,
    padding: 4
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingTop: 6,
    marginTop: 4,
    fontWeight: 'black',
    fontSize: 10
  },
  synthesisSectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 6,
    padding: 6,
    borderRadius: 4
  },
  bestPresta: {

  },
  selectedPresta: {
    borderWidth: 2,
    borderColor: '#004681',
    borderRadius: 8,
  },
  footer: {
    fontSize: 10,
    color: '#6B7280',
    textAlign: 'center',
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
    position: 'absolute', // <- ajoute ça
    bottom: 20,           // <- ajuste selon besoin
    left: 0,
    right: 0,
  },
  statusBadge: {
    marginVertical: 4,
    padding: 6,
    width: 120,
    textAlign: 'center',
    borderRadius: 20,
    fontSize: 10,
    fontWeight: 'bold'
  },
  analyzeInfo: {
    backgroundColor: '#fff7ed',
    borderColor: '#FED7AA',
    borderWidth: 1,
    borderRadius: 8,
    padding: 12,
    marginTop: 12,
    fontSize: 10,
    marginHorizontal: 24,
  },
  noteGlobale: {
    width: '100%',
    backgroundColor: "rgba(218, 112, 39, 0.15)",
    textAlign: 'center',
    paddingVertical: 6,
    paddingHorizontal: 8,
    marginTop: 8,
    borderRadius: 8
  },
  noteGlobaleValue: {
    fontSize: 8,
    fontWeight: 'bold',
  },
  noteGlobaleLabel: {
    fontSize: 6,
    color: '#6B7280',
    marginBottom: 2,
    fontWeight: 'bold',
  },
  notesSyntheseGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: 2, // si ton moteur de rendu supporte gap
  },
  noteSyntheseItem: {
    flexBasis: '48%', // 2 colonnes par ligne avec un petit espace
    marginBottom: 8,
  },
  noteSyntheseLabel: {
    fontSize: 4,
    color: '#6B7280',
  },

  expiredBadge: {
    backgroundColor: '#6b7280',
    color: 'white',
    fontSize: 6,
    textAlign: 'center',
    borderRadius: 25,
    width: '50%',
    marginHorizontal: 'auto',
    paddingVertical: 2,
    marginBottom: 4,
  }

});

interface AnalyseRecapPDFProps {
  commande: any;
  user: any;
  techNotes: any;
  calculateFinancialScore: (prestataires: any[]) => { [id: string]: number };
  getNoteGlobale: (techNotes: any, prestaId: string) => string;
  selectedPrestataire: number | null;
}

const AnalyseRecapPDF: React.FC<AnalyseRecapPDFProps> = ({
  commande,
  user,
  techNotes,
  calculateFinancialScore,
  getNoteGlobale,
  selectedPrestataire
}) => {

  console.log("Rendering PDF with commande:", commande);
  console.log("Tech Notes:", techNotes);
  console.log("Selected Prestataire:", selectedPrestataire);
  console.log("User:", user);
  const today = new Date().toLocaleString('fr-FR');


  // Calculer les scores financiers (fonction externe fournie, on garde)
  const financialScores = calculateFinancialScore(commande.prestataires || []);

  // Trouver le meilleur prestataire (note totale la plus élevée) — exclure les expirés
  let bestPrestaId = selectedPrestataire;
  let bestScore = 0;

  // NOTE: on itère sur les prestataires non expirés pour déterminer le meilleur
  (commande.commandes || [])
    .filter(p => p.id_status !== 12)
    .forEach((presta, idx) => {
      const id = idx.toString();
      const techScore = Number(getNoteGlobale(techNotes, id)) || 0;
      const finScore = calculateNoteFinanciere(presta.id);
      const totalScore = techScore * 0.55 + finScore * 0.45;
      if (totalScore > bestScore) {
        bestScore = totalScore;
        bestPrestaId = presta.id;
      }
    });

  const creationDate = commande.created_at
    ? new Date(commande.created_at).toLocaleString('fr-FR')
    : today;

  const getCandidatureDate = (commandeId: string) => {
    if (!commande?.historique) {
      console.warn('Operation historique is missing');
      return null;
    }

    const entry = commande.historique.find(
      (h: any) =>
        h.prefix === 'Candidature' &&
        h.destinataire?.toString() === commandeId?.toString()
    );

    if (!entry) {
      console.warn(`No candidature entry found for commande ${commandeId}`);
      return null;
    }

    return entry.created_at;
  };

  const truncateText = (text) => {
    if (!text) return "-";
    return text.length > 300 ? text.substring(0, 300) + "..." : text;
  };


  const Footer: React.FC = () => (
    <Text
      style={{
        fontSize: 10,
        color: '#6B7280',
        textAlign: 'center',
        paddingTop: 8,
        borderTopWidth: 1,
        borderTopColor: '#E5E7EB',
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
      }}
      render={({ pageNumber, totalPages }) =>
        `Document généré par Centralis • ${new Date().toLocaleString('fr-FR')} • ${user?.email || ''} • Page ${pageNumber} / ${totalPages}`
      }
      fixed
    />
  );

  // Puis à la fin de ta <Page> :


  /**
   * Nouvelle fonction de calcul des notes financières selon ton cahier des charges :
   * - ne considère que les offres valides (prix_total défini et id_status !== 12)
   * - si 1 presta valide => 10
   * - si 2 prestas valides => cheapest 10, other 0
   * - si 3 prestas valides => cheapest 10, middle 5, most expensive 0
   * - généralisation : score = ((n-1-rank)/(n-1)) * 10
   */
  function calculateNoteFinanciere(prestaId: string): number {
    const montants = (commande?.commandes || [])
      .filter(p => p.id_status !== 12 && p.prix_total !== undefined && p.prix_total !== null)
      .map(p => ({ id: p.id?.toString?.() ?? String(p.id), montant: Number(p.prix_total) }));

    if (!montants.length) return 0;

    // Trier par montant croissant
    montants.sort((a, b) => a.montant - b.montant);

    // Trouver l'index du prestataire courant
    const idx = montants.findIndex(m => m.id.toString() === prestaId.toString());
    if (idx === -1) return 0; // prestataire expiré ou sans montant

    const n = montants.length;
    if (n === 1) return 10;

    // Règle généralisée : meilleur (rank 0) => 10 ; pire (rank n-1) => 0 ; intermédiaire interpolés
    const score = ((n - 1 - idx) / (n - 1)) * 10;
    // Dans les cas particuliers (2 ou 3) ça donne exactement ce que tu as demandé.
    return Math.round(score * 100) / 100;
  }

  function formatFR(number: number | undefined | null) {
    if (number === undefined || number === null) return '0,00';
    const parts = Number(number).toFixed(2).split('.');
    // Ajoute un espace normal tous les 3 chiffres
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(',');
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* En-tête avec informations utilisateur et date */}
        <View style={styles.header} wrap={false}>
          <View>
            <Text style={styles.userInfo}>{user?.email || 'Utilisateur'}</Text>
            <Text style={styles.dateInfo}>Document généré le {today}</Text>
          </View>
        </View>

        {/* Informations générales */}
        <View style={styles.infoSection} wrap={false}>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>
              N° {commande.numero || `MS-${commande.id}`} • MS
            </Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Lot technique:</Text>
            <Text style={styles.infoValue}>{commande.lot_technique?.nom || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Département:</Text>
            <Text style={styles.infoValue}>{commande.lot_departement.departement.id} - {commande.lot_departement.departement.nom || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Organisme:</Text>
            <Text style={styles.infoValue}>{commande.organisme.nom || '-'}</Text>
          </View>
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Date de création:</Text>
            <Text style={styles.infoValue}>{creationDate}</Text>
          </View>
        </View>

        {/* Analyse de l'offre technique */}
        <Text style={styles.sectionTitle}>Analyse de l'offre technique</Text>
        <View style={styles.sectionContent}>
          <View style={styles.prestaComparison}>
            {commande.commandes && commande.commandes.map((presta: any, idx: number) => {
              const isSelected = selectedPrestataire === idx;
              const isBest = presta.id === bestPrestaId;
              const isExpired = presta.id_status === 12;
              const techScore = Number(getNoteGlobale(techNotes, idx.toString()));


              return (
                <View
                  key={`tech-${idx}`}
                  style={[
                    styles.prestaColumn,
                    isSelected ? styles.selectedPresta : null,
                    isBest ? styles.bestPresta : null
                  ]}
                >
                  <View style={styles.prestaHeader}>

                    {isExpired ? (
                      <Text style={[styles.prestaDate, styles.expiredBadge]}>
                        Expirée
                      </Text>
                    ) : isBest ? (
                      <Text style={[styles.prestaDate, { backgroundColor: '#DA7027', borderRadius: 25, color: 'white', width: '75%', paddingVertical: 2, marginHorizontal: 'auto', marginBottom: 4 }]}>
                        Entreprise mieux disante
                      </Text>
                    ) : (
                      <Text style={[styles.prestaDate, { backgroundColor: '#6b7280', borderRadius: 25, color: 'white', width: '75%', paddingVertical: 2, marginHorizontal: 'auto', marginBottom: 4 }]}>
                        Non retenu à ce stade
                      </Text>
                    )}
                    <Text style={styles.prestaName}>{presta.contrat.entite.nom}</Text>
                    <Text style={styles.prestaDate}>
                      {isExpired
                        ? "Offre non reçue"
                        : getCandidatureDate(presta.id)
                          ? `Offre reçue le ${new Date(getCandidatureDate(presta.id)).toLocaleString("fr-FR")}`
                          : ""}
                    </Text>
                  </View>

                  <Text style={styles.critereTitle}>Réponse technique au besoin :</Text>
                  <Text style={styles.responseTechnique}>
                    {isExpired
                      ? "-"
                      : `${(presta.reponse || "").substring(0, 300)}${(presta.reponse || "").length > 300 ? "..." : ""
                      }`}
                  </Text>

                  {/* Opérationnel */}
                  <Text style={styles.critereTitle}>
                    Modes Opératoires pour l'éxecution du marché :
                  </Text>
                  <Text style={{ fontWeight: 500, fontSize: 6, marginBottom: 4 }}>{isExpired ? "-" : techNotes[idx.toString()]?.organisation?.description || "-"}</Text>
                  <Text style={{ fontSize: 5, color: '#6B7280' }}>
                    Commentaire :
                  </Text>
                  <Text style={{ fontWeight: 500, fontSize: 5, color: '#6B7280', marginBottom: 6 }}>{isExpired ? "-" : truncateText(techNotes[idx.toString()]?.organisation?.commentaire)}</Text>

                  {/* Humain */}
                  <Text style={styles.critereTitle}>
                    Moyens Humains et Materiels dédiés au marché :
                  </Text>
                  <Text style={{ fontWeight: 500, fontSize: 6, marginBottom: 4 }}>{isExpired ? "-" : techNotes[idx.toString()]?.moyens?.description || "-"}</Text>
                  <Text style={{ fontSize: 5, color: '#6B7280' }}>
                    Commentaire :
                  </Text>
                  <Text style={{ fontWeight: 500, fontSize: 5, color: '#6B7280', marginBottom: 6 }}>{isExpired ? "-" : truncateText(techNotes[idx.toString()]?.moyens?.commentaire)}</Text>

                  {/* Environnement */}
                  <Text style={styles.critereTitle}>
                    Mesures en matière Environnementale & Sociale :
                  </Text>
                  <Text style={{ fontWeight: 500, fontSize: 6, marginBottom: 4 }}>{isExpired ? "-" : techNotes[idx.toString()]?.social?.description || "-"}</Text>
                  <Text style={{ fontSize: 5, color: '#6B7280' }}>
                    Commentaire :
                  </Text>
                  <Text style={{ fontWeight: 500, fontSize: 5, color: '#6B7280', marginBottom: 6 }}>{isExpired ? "-" : truncateText(techNotes[idx.toString()]?.social?.commentaire)}</Text>



                  {/* Notes */}
                  <View style={styles.noteSection}>
                    <Text style={styles.noteTitle}>Notes:</Text>
                    <View style={styles.notesGrid}>
                      <View style={styles.noteItem}>
                        <Text style={styles.noteLabel}>Modes Opératoires pour l'éxecution du marché</Text>
                        <Text style={styles.noteValue}>
                          {isExpired
                            ? "-"
                            : `${(
                              techNotes[idx.toString()]?.organisation?.note || 0
                            ).toLocaleString('fr-FR', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}/5`}
                        </Text>
                      </View>
                      <View style={styles.noteItem}>
                        <Text style={styles.noteLabel}>Moyens Humains et Materiels dédiés au marché</Text>
                        <Text style={styles.noteValue}>
                          <Text style={styles.noteValue}>
                            {isExpired
                              ? "-"
                              : `${(
                                techNotes[idx.toString()]?.moyens?.note || 0
                              ).toLocaleString('fr-FR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}/4`}
                          </Text>
                        </Text>
                      </View>
                      <View style={styles.noteItem}>
                        <Text style={styles.noteLabel}>Mesures en matière Environnementale & Sociale</Text>
                        <Text style={styles.noteValue}>
                          <Text style={styles.noteValue}>
                            {isExpired
                              ? "-"
                              : `${(
                                techNotes[idx.toString()]?.social?.note || 0
                              ).toLocaleString('fr-FR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}/1`}
                          </Text>
                        </Text>
                      </View>
                    </View>
                    <View style={styles.noteGlobale}>
                      <Text style={styles.noteGlobaleLabel}>Note technique</Text>
                      <Text style={styles.noteGlobaleValue}>
                        <Text style={styles.noteValue}>
                          {isExpired
                            ? "-"
                            : `${techScore.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} / 10`
                          }
                        </Text>

                      </Text>
                    </View>
                  </View>
                </View>
              );
            })}
          </View>
        </View>
        <View wrap={false} break>

          {/* Analyse de l'offre financière */}
          <Text style={styles.sectionTitle}>Analyse de l'offre financière</Text>
          <View style={styles.sectionContent}>
            <View style={styles.prestaComparison}>
              {commande.commandes && commande.commandes.map((presta: any, idx: number) => {

                const isSelected = selectedPrestataire === idx;
                const isBest = presta.id === bestPrestaId;
                const isExpired = presta.id_status === 12;
                const techScore = Number(getNoteGlobale(techNotes, idx.toString()));
                const noteFin = calculateNoteFinanciere(presta.id);

                return (
                  <View
                    key={`finance-${idx}`}
                    style={[
                      styles.prestaColumn,
                      isSelected ? styles.selectedPresta : null,
                      isBest ? styles.bestPresta : null
                    ]}
                  >
                    <View style={styles.prestaHeader}>
                      {isExpired ? (
                        <Text style={[styles.prestaDate, styles.expiredBadge]}>
                          Expirée
                        </Text>
                      ) : isBest ? (
                        <Text style={[styles.prestaDate, { backgroundColor: '#DA7027', borderRadius: 25, color: 'white', width: '75%', paddingVertical: 2, marginHorizontal: 'auto', marginBottom: 4 }]}>
                          Entreprise mieux disante
                        </Text>
                      ) : (
                        <Text style={[styles.prestaDate, { backgroundColor: '#6b7280', borderRadius: 25, color: 'white', width: '75%', paddingVertical: 2, marginHorizontal: 'auto', marginBottom: 4 }]}>
                          Non retenu à ce stade
                        </Text>
                      )}
                      <Text style={styles.prestaName}>{presta.contrat.entite.nom}</Text>
                      <Text style={styles.prestaDate}>
                        {isExpired
                          ? "Offre non reçue"
                          : getCandidatureDate(presta.id)
                            ? `Offre reçue le ${new Date(getCandidatureDate(presta.id)).toLocaleString("fr-FR")}`
                            : ""}
                      </Text>
                    </View>

                    <View style={styles.financeTable}>
                      <View style={[styles.tableRow, styles.tableHeaderRow]}>
                        <Text style={styles.tableCell}>Article</Text>
                        <Text style={styles.tableCell}>Prix HT</Text>
                      </View>

                      {presta.sections?.map((section: any) =>
                        section.articles?.map((article: any) => {
                          const truncatedName = article.nom.length > 35
                            ? article.nom.substring(0, 32) + "..."
                            : article.nom;
                          return (
                            <View style={styles.tableRow} key={article.id}>
                              <Text style={[styles.tableCell, { fontSize: 8 }]}>{truncatedName}</Text>
                              <Text style={[styles.tableCell, { fontSize: 8, textAlign: 'right' }]}>
                                {formatFR(article?.prix)} €
                              </Text>
                            </View>
                          );
                        })
                      )}

                      <View style={[styles.totalRow, { fontSize: 9 }]}>
                        <Text>Total HT: {formatFR(presta.prix_total)} €</Text>
                      </View>
                    </View>

                    <View style={styles.noteGlobale}>
                      <Text style={styles.noteGlobaleLabel}>Note financière</Text>
                      <Text style={styles.noteGlobaleValue}>
                        {isExpired ? (
                          "-"
                        ) : (
                          <>
                            {noteFin} / 10
                          </>
                        )}
                      </Text>
                    </View>
                  </View>
                );
              })}
            </View>
          </View>
        </View>
        <View wrap={false} break>
          {/* Synthèse de l'analyse */}
          <Text style={styles.sectionTitle}>Synthèse de l'analyse des offres</Text>
          <View style={styles.sectionContent}>

            <View style={styles.prestaComparison}>
              {commande.commandes && commande.commandes.map((presta: any, idx: number) => {
                const isSelected = selectedPrestataire === idx;
                const isBest = presta.id === bestPrestaId;

                const techScore = getNoteGlobale(techNotes, idx.toString());
                const finScore = (presta?.note_financiere !== undefined && presta?.note_financiere !== null)
                  ? presta.note_financiere
                  : calculateNoteFinanciere(presta.id);
                const safeFinScore = typeof finScore === 'number' && !isNaN(finScore) ? finScore : 0;
                const totalScore = (Number(techScore) * 0.55) + (safeFinScore * 0.45);
                const isExpired = presta.id_status === 12;

                return (
                  <View
                    key={`synthese-${idx}`}
                    style={[
                      styles.prestaColumn,
                      isSelected ? styles.selectedPresta : null,
                      isBest ? styles.bestPresta : null
                    ]}
                  >

                    <View style={styles.prestaHeader}>
                      {isExpired ? (
                        <Text style={[styles.prestaDate, styles.expiredBadge]}>
                          Expirée
                        </Text>
                      ) : isBest ? (
                        <Text style={[styles.prestaDate, { backgroundColor: '#DA7027', borderRadius: 25, color: 'white', width: '75%', paddingVertical: 2, marginHorizontal: 'auto', marginBottom: 4 }]}>
                          Entreprise mieux disante
                        </Text>
                      ) : (
                        <Text style={[styles.prestaDate, { backgroundColor: '#6b7280', borderRadius: 25, color: 'white', width: '75%', paddingVertical: 2, marginHorizontal: 'auto', marginBottom: 4 }]}>
                          Non retenu à ce stade
                        </Text>
                      )}
                      <Text style={styles.prestaName}>{presta.contrat.entite.nom}</Text>
                      <Text style={styles.prestaDate}>
                        {isExpired
                          ? "Offre non reçue"
                          : getCandidatureDate(presta.id)
                            ? `Offre reçue le ${new Date(getCandidatureDate(presta.id)).toLocaleString("fr-FR")}`
                            : ""}
                      </Text>
                    </View>


                    <View style={styles.notesSyntheseGrid}>
                      <View style={styles.noteSyntheseItem}>
                        <Text style={styles.noteSyntheseLabel}>Note Technique&nbsp;
                        </Text>
                        <Text style={{ fontSize: 6, fontWeight: 'bold', backgroundColor: '#F3F4F6', padding: 4, borderRadius: 4, marginTop: 4 }}>
                          {isExpired ? "-" :
                            `${techScore?.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/10`
                          }
                        </Text>
                      </View>
                      <View style={styles.noteSyntheseItem}>
                        <Text style={styles.noteSyntheseLabel}>Note pondérée&nbsp;
                          <Text style={{
                            fontSize: 4, fontWeight: 'bold',
                            color: 'black', marginLeft: "auto",
                          }}> 55%</Text>
                        </Text>
                        <Text style={{ fontSize: 6, fontWeight: 'bold', backgroundColor: '#F3F4F6', padding: 4, borderRadius: 4, marginTop: 4 }}>
                          {isExpired ? (
                            "-"
                          ) : (
                            <>
                              {(Number(techScore) * 0.55)?.toLocaleString('fr-FR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}/5,50{" "}
                              <Text style={{ fontSize: 4, color: '#6B7280', marginLeft: 'auto' }}>
                                (55% de{" "}
                                {techScore?.toLocaleString('fr-FR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                                )
                              </Text>
                            </>
                          )}
                        </Text>
                      </View>
                      <View style={styles.noteSyntheseItem}>
                        <Text style={styles.noteSyntheseLabel}>Note Financière&nbsp;
                        </Text>
                        <Text style={{ fontSize: 6, fontWeight: 'bold', backgroundColor: '#F3F4F6', padding: 4, borderRadius: 4, marginTop: 4 }}>
                          {isExpired ? "-" :
                            `${safeFinScore?.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/10`
                          }
                        </Text>
                      </View>

                      <View style={styles.noteSyntheseItem}>
                        <Text style={styles.noteSyntheseLabel}>Note pondérée&nbsp;
                          <Text style={{
                            fontSize: 4, fontWeight: 'bold',
                            color: 'black', marginLeft: "auto",
                          }}> 45%</Text>
                        </Text>
                        <Text style={{ fontSize: 6, fontWeight: 'bold', backgroundColor: '#F3F4F6', padding: 4, borderRadius: 4, marginTop: 4 }}>
                          {isExpired ? (
                            "-"
                          ) : (
                            <>
                              {(safeFinScore * 0.45)?.toLocaleString('fr-FR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}/4,50{" "}
                              <Text style={{ fontSize: 4, color: '#6B7280', marginLeft: 'auto' }}>
                                (45% de{" "}
                                {safeFinScore?.toLocaleString('fr-FR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                                )
                              </Text>
                            </>
                          )}
                        </Text>
                      </View>

                      <View style={styles.noteGlobale}>
                        <Text style={styles.noteGlobaleLabel}>Note globale</Text>
                        <Text style={styles.noteGlobaleValue}>
                          {isExpired ? (
                            "-"
                          ) : (
                            <>
                              {totalScore?.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} / 10
                            </>
                          )}
                        </Text>
                      </View>
                    </View>

                    {
                      isSelected && (
                        <View style={[styles.noteSection, { alignItems: 'center' }]}>
                          <Text style={[styles.noteTitle, { color: '#004681' }]}>
                            Prestataire Sélectionné
                          </Text>
                        </View>
                      )
                    }
                  </View>
                );
              })}
            </View>
          </View>

          {commande.formatedAnalyzeLancee && commande.analyzeOperateur && (
            <View wrap={false}>
              <Text style={styles.analyzeInfo}>Analyse clôturée le {commande.formatedAnalyzeLancee} par {commande.analyzeOperateur}</Text>
            </View>
          )}
        </View>

        <Footer />
      </Page>
    </Document >
  );
};

export default AnalyseRecapPDF;